<template>
    <CodiceFeanorView tool-module="hex" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
